export default __webpack_public_path__ + "static/media/video.76f2a87b.svg";